import { useEffect } from "react";

// Marks a page as private: not indexed by search engines. Removed on unmount
// so public pages (home, about) stay indexable.
export function useNoIndex() {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);
}
